import type { ReactNode } from 'react'

// 페이지 제목 + 설명 공통 헤더. 구조적 — 선택 eyebrow + 제목 + 설명 + 하단 rule.
// actions: 우측 정렬 슬롯(교차 링크·버튼 등, 선택).
export function PageHeader({
    eyebrow,
    title,
    description,
    actions,
}: {
    eyebrow?: string
    title: string
    description?: string
    actions?: ReactNode
}) {
    return (
        <header className='border-border mb-4 border-b pb-3'>
            {eyebrow ? (
                <div className='admin-eyebrow mb-1'>{eyebrow}</div>
            ) : null}
            <div className='flex items-start justify-between gap-3'>
                <div>
                    <h1 className='text-foreground text-lg font-semibold tracking-tight'>
                        {title}
                    </h1>
                    {description ? (
                        <p className='text-muted-foreground mt-1 text-[13px]'>
                            {description}
                        </p>
                    ) : null}
                </div>
                {actions ? <div className='shrink-0'>{actions}</div> : null}
            </div>
        </header>
    )
}
